import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { TOURIST_SERVICE_TYPE } from '../../../shared/constants';
import { splitField, splitFieldForms } from '../../../shared/utils';
import serviceDetailBaseStyles from '../../../styles/atoms/service-detail-base.module.scss';
import LocationFormField from '../location-form-field';
import SchedulesSelectionFormField from '../schedules-selection-form-field';
import ServicesListFormField from '../services-list-form-field';
import TouristAttractionFormField from '../tourist-attraction-form-field';

type ThemeParkPreviewProps = {
  detailData: any;
};

export const ThemeParkPreview: FunctionComponent<ThemeParkPreviewProps> = ({
  detailData = {},
}) => {
  const router = useRouter();
  const [locale, setLocale] = useState(router?.locale);
  const t = useTranslations('viewOffer');
  useEffect(() => {
    if(router.locale) {
      setLocale(router?.locale)
    }
  }, [router?.locale])
  return (
    <div className={serviceDetailBaseStyles.detailContainer}>
      <LocationFormField value={detailData.ubicacion} viewOnly={true} />

      <div className={serviceDetailBaseStyles.field}>
        <p>{t('horario')}</p>
        <SchedulesSelectionFormField
          viewList={detailData.horario_parque_tematico}
          viewOnly={true}
        />
      </div>

      <div className={serviceDetailBaseStyles.field}>
        <p>{t('incluye')}</p>
        <TouristAttractionFormField
          themeParkID={detailData.id_parque_tematico}
          value={detailData.atraccion_parque_tematico}
          viewOnly={true}
        />
      </div>

      {splitField(detailData.actividades_incluidas, locale) !== '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('actividadesIncluidas')}</p>
          <p>{splitField(detailData.actividades_incluidas, locale)}</p>
        </div>
      )}

      {splitField(detailData.recomendaciones, locale) !== '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('recomendacioneSeguridad')}</p>
          <p>{splitField(detailData.recomendaciones, locale)}</p>
        </div>
      )}

      {splitField(detailData.reglamento, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('reglamento')}</p>
          <p>{splitField(detailData.reglamento, locale)}</p>
        </div>
      )}

      <div className={serviceDetailBaseStyles.field}>
        <p>{t('incluye')}</p>
        <ServicesListFormField
          value={detailData?.servicio_adicional_parque_tematico}
          viewOnly={true}
          touristServiceType={TOURIST_SERVICE_TYPE.THEME_PARK}
        />
      </div>
    </div>
  );
};
